export const OrderCI_PDFATTACHMENT_STATE_PATH = 'pdfAttachments';

export class PdfAttachmentsStateModel {
	attachments: PdfAttachmentsDataModel;

	constructor() {
		this.attachments = new PdfAttachmentsDataModel();
	}
}

export class PdfAttachmentsDataModel {
	data?: any;

	constructor() {
		this.data = [];
	}
}
